import _ from "underscore";
import Environment from "../../common/environment";
import imkt from "../../imkt";

export default class FeatureFlaggerContainer  {
  domRoot: HTMLElement;
  variants: NodeList;
  params: {
    flagKey: string,
    flagType: string,
    flagParameter: string,
    flagValueType: string,
    flagDefaultValue: string
    contentType: string;
  };
  flagKey: string;
  flagType: string;
  flagParameter: string;
  flagValueType: string;
  flagDefaultValue: string;
  contentType: string;

  defaultValue: any;

  constructor(domRoot: HTMLElement, params: any) {
    this.domRoot = domRoot;
    this.params = {
      ...params
    };
    
    this.flagKey = this.params.flagKey;
    this.flagType = this.params.flagType;
    this.flagParameter = this.params.flagParameter;
    this.flagValueType = this.params.flagValueType;
    this.flagDefaultValue = this.params.flagDefaultValue;
    this.contentType = this.params.contentType;
    this.variants = this.domRoot.querySelectorAll("[data-flag-value]");

    this.defaultValue;

    if (this.flagValueType == "string") {
      this.defaultValue = this.flagDefaultValue;
    } else if (this.flagValueType == "number") {
      this.defaultValue = Number(this.flagValueType);
    } else if (this.flagValueType == "boolean" && this.flagDefaultValue == "false") {
      this.defaultValue = false;
    }

    this.init();
  }
  
  async init() {
    const searchParams = window.location.search.replace('?','').split('&');
    const searchParamKeys = searchParams.map(searchParam => { return searchParam.split('=')[0] });
    if (!Environment.isProduction() && searchParamKeys.includes(this.flagKey)) {
      // for testing purposes ONLY in staging environments, we skip the flag fetch to allow for testing with a URL parameter
    } else if (this.flagType == "gate") {
      await this.fetchGateValue();
    } else {
      await this.fetchExperimentValue();
    }
  }

  displayMatcher(experimentTextValue: string) {
    const matchingElement: HTMLElement | undefined = Array.from(this.variants)
      .filter((variant): variant is HTMLElement => variant instanceof HTMLElement)
      .find(variant => variant.dataset.flagValue === experimentTextValue);
  
    if (matchingElement && this.contentType == "html") {
      matchingElement.style.display = "block";
    } else if (matchingElement && this.contentType == "script") {
      var tag = document.createElement("script");
      tag.innerHTML = matchingElement.innerHTML;
      document.head.appendChild(tag);
    } else if (matchingElement && this.contentType == "style") {
      matchingElement.removeAttribute("type");
    }
  }

  fetchExperimentValue = async () => {
    const experimentResult = await imkt.utils.featureGate.getExperimentValue(
      this.params.flagKey,
      this.params.flagParameter,
      this.defaultValue
    );
    this.displayMatcher(experimentResult.toString());
  }

  fetchGateValue = async () => {
    const gateResult = await imkt.utils.featureGate.checkGate(this.params.flagKey);
    this.displayMatcher(gateResult.toString());
  }
  
}